export function toUtcNoon(date: Date, mode: 'local' | 'utc' = "local"): Date {
  const year = mode === "utc" ? date.getUTCFullYear() : date.getFullYear();

  const month = mode === "utc" ? date.getUTCMonth() : date.getMonth();

  const day = mode === "utc" ? date.getUTCDate() : date.getDate();

  return new Date(Date.UTC(year, month, day, 12, 0, 0, 0));
}

export function restoreSubmittedDate(value: string): Date {
  const date = new Date(value);
  const utcHour = date.getUTCHours();

  if (utcHour >= 15 && utcHour <= 22) {
    date.setUTCDate(date.getUTCDate() + 1);
  }

  return toUtcNoon(date, "utc");
}

export function toLocalCalendarDate(value: string): Date {
  const date = restoreSubmittedDate(value);

  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
  );
}
